/**
 * Receives a function that is executed in an interval as long as it returns true.
 */
export const waitUntil = (fn: () => boolean) => {
  let tickId: ReturnType<typeof setTimeout>;
  const check = (resolve: () => void) => {
    const isReady = fn();
    if (isReady) {
      resolve();
    } else {
      tickId = setTimeout(() => check(resolve), 100);
    }
  };

  return {
    cancel: () => clearTimeout(tickId),
    waiter: new Promise<void>(resolve => {
      check(resolve);
    }),
  };
};
